import { render, staticRenderFns } from "./year.vue?vue&type=template&id=2f0a82e2&scoped=true&"
import script from "./year.vue?vue&type=script&lang=js&"
export * from "./year.vue?vue&type=script&lang=js&"
import style0 from "./year.vue?vue&type=style&index=0&id=2f0a82e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a82e2",
  null
  
)

export default component.exports